<template>
    <div class="col-lg-4 m-auto">
        <card :title="$t('edit_project')">
            <form @submit.prevent="register" @keydown="form.onKeydown($event)">
                <!-- Name -->
                <div class="form-group">
                    <label>{{ $t('name') }}</label>
                    <input v-model="form.name"
                        :class="{ 'is-invalid': form.errors.has('name') }"
                        class="form-control"
                        type="text"
                        name="name">
                    <has-error :form="form"
                        field="name" />
                </div>

                <!-- Company -->
                <div class="form-group">
                    <label>{{ $t('company') }}</label>
                    <select v-model="form.company"
                        :class="{ 'is-invalid': form.errors.has('company') }"
                        class="form-control"
                        name="company">
                        <option value="" selected>{{ $t('select_company') }}</option>
                        <option v-bind:key="company.id" v-for="company in companies" v-bind:value="company.id">
                            {{ company.name }}
                        </option>
                    </select>
                    <has-error :form="form"
                        field="company" />
                </div>

                <div class="form-group">
                    <span class="switch">
                        <input v-model="form.active"
                                :class="{ 'is-invalid': form.errors.has('active') }"
                                class="switch"
                                type="checkbox"
                                name="active"
                                id="active">
                        <label class="form-check-label" for="active">
                            {{ $t('active') }}?
                        </label>
                    </span>
                </div>
            </form>
            <div class="text-right" slot="footer">
                <button class="btn btn-primary" @click="saveProject">{{ $t('send') }}</button>
            </div>
        </card>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";

export default {
    data() {
        return {
            loading: false,
            companies : null,
            error: null,
            form: new Form({
                name: "",
                active: true,
                company: ""
            })
        };
    },
    created() {
        this.fetchData(this.id);
    },
    computed : {
        id(){
            return this.$route.params.id ? this.$route.params.id : false;
        }
    },
    methods: {
        async fetchData(id) {
            if(id) this.fetchProject(id)
            this.fetchCompanies();
        },
        async fetchProject(id){
            const { data } = await axios.get("/api/project/" + id);
        
            this.form.name = data.name;
            this.form.active = data.active;
            this.form.company = data.company_id;
        },
        async fetchCompanies(){
            let { data } = await axios.get("/api/company")
            this.companies = data;
        },
        async saveProject() {
            if(this.id){
                const { data } = await this.form.patch("/api/project/" + this.id);
            } else {
                const { data } = await this.form.post("/api/project");
            }

            this.form.reset();
            this.$router.push({ name: 'admin.projects' });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/projects/form.vue